import type { ReactNode } from 'react';
import { Breadcrumbs, type BreadcrumbItem } from '../components/Breadcrumbs.js';
import { cn } from '../lib/cn.js';

export interface TopBarProps {
  breadcrumbs: BreadcrumbItem[];
  /** Left cluster after the breadcrumbs (rail toggle, back). */
  leading?: ReactNode;
  /** Right cluster: clock, status pill, context label, notification bell, user menu. gap-6. */
  right?: ReactNode;
  className?: string;
}

/** Context bar (DESIGN_SYSTEM section 7.2): h-12, bg --bg, bottom border --line. */
export function TopBar({ breadcrumbs, leading, right, className }: TopBarProps) {
  return (
    <header className={cn('flex h-12 shrink-0 items-center justify-between gap-6 border-b border-line bg-bg pl-5 pr-5', className)}>
      <div className="flex min-w-0 items-center gap-3">
        {leading}
        <Breadcrumbs items={breadcrumbs} />
      </div>
      {right ? <div className="flex shrink-0 items-center gap-6 font-mono text-2xs uppercase tracking-[0.18em] text-mute">{right}</div> : null}
    </header>
  );
}

/** Brand-red mono context label for the top bar right cluster (e.g. environment). */
export function TopBarContext({ children }: { children: ReactNode }) {
  return <span className="text-brand-text">{children}</span>;
}
